/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @param {Object} props            Properties passed to the function.
 * @param {Object} props.attributes Available block attributes.
 * @return {WPElement} Element to render.
 */
export default function save({ attributes }) {
  const {
    counterStart,
    counterEnd,
    counterCurrency,
    counterDecimals,
    counterAppend,
    counterSeperator,
    counterDelay,
    flexClass,
  } = attributes;

  const newClass = ['bf_flex', flexClass];
  const newClasses = newClass.join(' ');

  const blockProps = useBlockProps.save({ className: newClasses });

  return (
    <div {...blockProps}>
      <span
        data-purecounter-start={counterStart}
        data-purecounter-end={counterEnd}
        data-purecounter-currency={counterCurrency}
        data-purecounter-decimals={counterDecimals}
        data-purecounter-seperator={false}
        className="purecounter"
      >
        {counterStart}
      </span>
      <span>{counterAppend}</span>
    </div>
  );
}
